export const DEFAULT_MATERIAL_DISPLACEMENT_SCALE = 0.018;
export const DEFAULT_MATERIAL_BLOOM_STRENGTH = 0.32;
